module.exports = __webpack_public_path__ + "static/orange-wave-812fa1da2adbd665f3394245c5cbba1e.png";